export const LOGO_CLASS_NAME = 'transition-all duration-300 ease-out';

export const ROUTER_PROPS = {
  slider: true,
  sliderProps: { adaptiveHeight: false, speed: 500, arrows: false },
};
